@if (assignees().length) {
  @if (trigger() === 'hover') {
    <div class="event-avatar-stack event-avatar-stack--inert">
      <ng-container [ngTemplateOutlet]="avatars" />
      @if (overflow(); as count) {
        @if (isMobile()) {
          <span class="event-avatar-stack__more event-avatar-stack__more--interactive" (click)="openDialog($event)">
            +{{ count }}
          </span>
        } @else {
          <sim-tooltip
            class="event-avatar-stack__more"
            [tooltip]="assigneesList"
            position="bottom"
            [delayedClosure]="true"
            [openTime]="100"
            [noPadding]="true"
          >
            +{{ count }}
          </sim-tooltip>
        }
      }
    </div>
  } @else {
    <div class="event-avatar-stack" (click)="openDialog($event)">
      <ng-container [ngTemplateOutlet]="avatars" />
      @if (overflow(); as count) {
        <span class="event-avatar-stack__more">+{{ count }}</span>
      }
    </div>
  }

  <ng-template #avatars>
    @for (assignee of visible(); track assignee.userId) {
      <sim-event-avatar
        [name]="assignee.userName || assignee.userEmail"
        [seed]="assignee.userId"
        [size]="size()"
        [status]="assignee.status"
        [attr.title]="assignee.userName || assignee.userEmail"
      />
    }
  </ng-template>

  <ng-template #assigneesList>
    <div class="event-assignees">
      <span class="event-assignees__title" i18n="@@EVENT_ASSIGNEES_LABEL">Assignee(s)</span>
      <div class="event-assignees__list">
        @for (user of assignees(); track user.userId) {
          <div class="event-assignees__row">
            <sim-event-avatar
              [name]="user.userName || user.userEmail"
              [seed]="user.userId"
              [size]="32"
              [status]="user.status"
            />
            <div class="event-assignees__info">
              <span class="event-assignees__name">{{ user.userName || user.userEmail }}</span>
              @if (user.userName && user.userEmail) {
                <span class="event-assignees__email">{{ user.userEmail }}</span>
              }
            </div>
          </div>
        }
      </div>
    </div>
  </ng-template>
} @else {
  <span class="event-avatar-stack__all" i18n="@@EVENT_OPEN_FOR_ALL">Open for all</span>
}
